import { useOverflowStatus as useOverflowStatusDI } from '@atlaskit/atlassian-navigation';
import { useTopMenus as useTopMenusDI } from '@atlassian/jira-navigation-apps-common/src/controllers/top-menus/index.tsx';
import {
	useAnalyticsEvents as useAnalyticsEventsDI,
	fireUIAnalytics as fireUIAnalyticsDI,
	type Attributes as AnalyticsAttributes,
} from '@atlassian/jira-product-analytics-bridge';
import type { UseOnClickType } from './types.tsx';

// @ts-expect-error - TS2741 - Property 'analytics' is missing in type '{}' but required in type 'UseOnClickProps'.
export const useOnClick: UseOnClickType = ({
	analytics,
	fireUIAnalytics = fireUIAnalyticsDI,
	onClick,
	useAnalyticsEvents = useAnalyticsEventsDI,
	useOverflowStatus = useOverflowStatusDI,
	useTopMenus = useTopMenusDI,
} = {}) => {
	const [, { off: closeMenu }] = useTopMenus();
	const { isVisible, closeOverflowMenu } = useOverflowStatus();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { actionSubjectId, ...analyticsRest } = analytics;

	return (event) => {
		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'navigationMenuItem',
		});

		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		fireUIAnalytics(analyticsEvent, actionSubjectId, {
			...analyticsRest,
			isInMore: !isVisible,
		} as AnalyticsAttributes);

		onClick && onClick(event);

		if (event.ctrlKey || event.metaKey) return;

		closeMenu();
		closeOverflowMenu();
	};
};
